import { keyBy } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { ComponentDesign } from '@paragon/contract-library';

import { RootState } from '..';

// A guide to getting component designs from a selector (some of these live in getSortedComponentDesignsAndSummariesSelectors.ts):

// 1. If you want a list of all the component designs that the client knows about: use Object.values(state.componentDesigns.data)
// 2. If you want #1, but excluding components currently being inserted: use getCommittedComponentDesigns
// 3. If you want #2, but natural sorted by name: use getNaturalSortedComponentDesigns
// 4. If you want #2, but sorted in the order that the user has requested: use getSortedComponentDesigns
// 5. If you want #3, but formatted with custom schemas for use in the navigation panel: use getSortedComponentDesignsForNavigationPanel
// 6. If you want some other combination of the above, create a new selector (the lame option) or create a selector
//      factory to consolidate all of the above (the cool option).

export const getCommittedComponentDesigns = createSelector(
  (state: RootState) => state.componentDesigns.data,
  (state: RootState) => state.componentDesigns.loadedState,
  (componentDesigns, componentDesignsLoadedState): readonly ComponentDesign[] =>
    // Filter out un-committed component designs (that are being inserted).
    Object.values(componentDesigns).filter(
      (componentDesign) => componentDesignsLoadedState[componentDesign.guid].committed,
    ),
);

export const getCommittedComponentDesignsByGuid = createSelector(
  getCommittedComponentDesigns,
  (committedComponentDesigns): { [guid: string]: ComponentDesign } =>
    keyBy(committedComponentDesigns, (componentDesign) => componentDesign.guid),
);
